module.exports = __webpack_public_path__ + "static/media/school_info.b404bdee.mp4";